module.exports = __webpack_public_path__ + "1345aec8c48606e5b48283705894cc0e.svg";